const getPlurial = (i18nSingular, i18nPlurial, data) => {
	if (data && (data.length > 1 || data > 1)) {
		return i18nPlurial
	}
	return i18nSingular
}
const getPlurialWithNumber = (i18nSingular, i18nPlurial, number) => {
	return number > 1 ? i18nPlurial : i18nSingular
}

const substringText = (text, shortNumber = 50) => {
	if (text) {
		if (text.length > shortNumber) {
			return text.substring(text, shortNumber) + '...'
		}
		return text
	}
	return ''
}

const substringNumber = (number, fixed = 4) => {
	if (number) {
		if (Number(number).toString().length > fixed) {
			return number.toFixed(fixed)
		}
		return number
	}
	return ''
}

export { getPlurial, getPlurialWithNumber, substringText, substringNumber }



// WEBPACK FOOTER //
// ./src/utils/StringUtils.js